<template>
  <div>
    <!-- Tab -->
    <tabs-menu
      v-if="false"
      :menu="menuTabs"
      :active="activeTabs"
    />

    <b-row class="match-height">
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          class="card-tiny-line-stats"
        >
          <h6 class="mb-2">
            Total Pengguna
          </h6>
          <b-media no-body>
            <b-media-aside
              class="mr-1"
            >
              <b-avatar
                size="36"
                variant="light-primary"
              >
                <feather-icon
                  size="20"
                  icon="UserIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h1 class="font-weight-bolder mb-0">
                {{ toThousands(users.meta.total) }}
              </h1>
              <b-card-text class="font-small-3 mb-0">
                orang
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <InfoSourceCard />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <UserGrowthChart
          :chart-data="userGrowth.statistic"
          :type="tabValue.value"
          :is-loading="isLoadingChart"
        />
      </b-col>
    </b-row>

    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="user/getUserList"
        :payload="{ type: tabValue.value }"
        @search="isRegistryOwner = null"
      >
        <template #action>
          <b-form-row>
            <b-col cols="auto">
              <b-form-select
                v-model="isRegistryOwner"
                :options="typeOptions"
                @change="onSelectUserType"
              />
            </b-col>
            <b-col>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                :disabled="isExporting"
                class="d-flex"
                @click.prevent="handleExport"
              >
                <b-spinner
                  v-if="isExporting"
                  small
                  class="mr-50"
                />
                <feather-icon
                  v-else
                  icon="FileTextIcon"
                  class="mr-50"
                />
                <span class="text-nowrap"> Export Data</span>
              </b-button>
            </b-col>
          </b-form-row>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="users.data"
        responsive
        :fields="tableFieldss"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >
        <!-- Column: Name -->
        <template #cell(name)="data">
          <div class="d-flex align-items-center">
            <b-avatar
              variant="primary"
              :text="initialText(data.item.name)"
              class="align-baseline"
              :src="linkStaging(data.item.photo)"
            />
            <span class="ml-1"> {{ data.item.name }}</span>
          </div>
        </template>

        <!-- Column: Verifikasi -->
        <template #cell(verification)="data">
          <b-badge
            v-if="data.item.phone_verified_at"
            class="mr-25"
            variant="success"
          >
            <feather-icon
              icon="CheckIcon"
              class="mr-25"
            />
            <span>Telepon</span>
          </b-badge>
          <b-badge
            v-if="data.item.email_verified_at"
            class="mr-25"
            variant="warning"
          >
            <feather-icon
              icon="CheckIcon"
              class="mr-25"
            />
            <span>Email</span>
          </b-badge>
        </template>

        <!-- Column: Produk Registry -->
        <template #cell(registryCout)="data">
          <span v-if="data.item.registry_product_count">
            {{ data.item.registry_product_count }} Produk
          </span>
          <span
            v-else
            class="text-muted"
          >
            0 Produk
          </span>
        </template>

        <!-- Column: Mini Wallet -->
        <template #cell(miniWallet)="data">
          <span class="text-nowrap">{{ toCurrency(data.item.mini_wallet_balance || 0) }}</span>
        </template>

        <!-- Column: Aktivitas Terakhir -->
        <template #cell(lastActivity)="data">
          <span v-if="data.item.last_active_at">
            {{ formatSelectDate(data.item.last_active_at, ['date','month','year','time']) }}
          </span>
        </template>

        <!-- Column: Tanggal Pendaftaran -->
        <template #cell(date)="data">
          {{ formatSelectDate(data.item.created_at, ['date','month','year','time']) }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- Dropdown -->
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="users.meta"
          action="user/getUserList"
          :payload="{ type: tabValue.value }"
        />
      </div>
    </b-card>

    <b-modal
      id="modal-user-detail"
      title="Detail Pengguna"
      hide-footer
    >
      <div v-if="userDetail">
        <user-detail :user="userDetail" />
        <!-- <pre>{{ userDetail }}</pre> -->
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserGrowthChart from '@core/components/user/UserGrowthChart.vue'
import InfoSourceCard from '@core/components/user/InfoSourceCard.vue'
import UserDetail from '@core/components/user/UserDetail.vue'
import Ripple from 'vue-ripple-directive'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TabsMenu from '@/layouts/components/custom/TabsMenu.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

import {
  BSkeletonTable,
  BButton,
  BMedia,
  BAvatar,
  BCard,
  BCardText,
  BFormRow,
  BRow,
  BCol,
  BTable,
  BSpinner,
  BMediaBody,
  BMediaAside,
  BBadge,
  VBTooltip, BFormSelect,
} from 'bootstrap-vue'

export default {
  components: {
    BFormSelect,
    UserGrowthChart,
    InfoSourceCard,
    UserDetail,
    BButton,
    BAvatar,
    BSkeletonTable,
    BCard,
    BCardText,
    BMedia,
    BFormRow,
    BRow,
    BCol,
    BTable,
    BSpinner,
    BMediaBody,
    BBadge,
    BMediaAside,
    TabsMenu,
    Pagination,
    TableHeader,
    TableAction,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'verification', label: 'Verifikasi' },
        { key: 'registryCout', label: 'Produk Registry' },
        { key: 'date', label: 'Tanggal Registrasi' },
        { key: 'lastActivity', label: 'Aktivitas Terakhir' },
        { key: 'actions', label: '' },
      ],
      userDetail: {},
      typeOptions: [
        {
          value: null,
          text: 'Semua Pengguna',
        },
        {
          value: true,
          text: 'Pemilik Registry',
        },
      ],
      isRegistryOwner: null,
      isExporting: false,
    }
  },
  computed: {
    ...mapState('user', ['users', 'userGrowth', 'userActivity', 'tabTypeList', 'isLoading', 'isLoadingChart']),
    keywordQuery() {
      return this.$route.query.keyword
    },
    tabValue() {
      return this.tabTypeList[this.activeTabs - 1]
    },
    tableFieldss() {
      if (this.tabValue.value === 'guest') {
        return [
          { key: 'name', label: 'Nama' },
          { key: 'email', label: 'Email' },
          { key: 'date', label: 'Tanggal Registrasi' },
          { key: 'actions', label: '' },
        ]
      }

      return [
        { key: 'name', label: 'Nama' },
        { key: 'verification', label: 'Verifikasi' },
        { key: 'registryCout', label: 'Produk Registry' },
        { key: 'miniWallet', label: 'Mini Wallet' },
        { key: 'lastActivity', label: 'Aktivitas Terakhir' },
        { key: 'date', label: 'Tanggal Registrasi' },
        { key: 'actions', label: '' },
      ]
    },
    menuTabs() {
      return [
        {
          access: null,
          title: 'Terdaftar',
          action: 'user/getUserList',
          payload: { type: 'buyer' },
          otherAction: () => {
            this.getChartUserRegistered({ interval: 'week', type: 'buyer' })
          },
        },
        {
          access: null,
          title: 'Belum Terdaftar',
          action: 'user/getUserList',
          payload: { type: 'guest' },
          otherAction: () => {
            this.getChartUserRegistered({ interval: 'week', type: 'guest' })
          },
        },
      ]
    },
    activeTabs() {
      return !this.$route.query.tab ? 1 : parseInt(this.$route.query.tab, 0)
    },
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: null,
          action: data => { this.showDetailModal(data) },
          icon: 'EyeIcon',
          title: 'Detail',
        },
        {
          access: null,
          to: null,
          action: data => { this.toExternalLink(`/registry/${data.username}`) },
          icon: 'GiftIcon',
          title: 'Lihat Registry',
        },
      ]
    },
  },
  async created() {
    try {
      const filterPicked = this.tabTypeList[this.activeTabs - 1]
      await this.getUserList({ type: filterPicked.value, ...this.query })
      await this.getChartUserRegistered({ interval: 'week', type: 'buyer' })
    } catch (error) {
      this.$swal({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        timer: 3000,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
  },
  methods: {
    ...mapActions('user', ['getUserList', 'getUserGrowth', 'exportUsers', 'getChartUserRegistered']),
    async handleExport() {
      this.isExporting = true
      await this.exportUsers({ isRegistryOwner: this.isRegistryOwner })
      this.isExporting = false
    },
    showDetailModal(item) {
      this.userDetail = item
      this.$bvModal.show('modal-user-detail')
    },
    async onSelectUserType() {
      const filterPicked = this.tabTypeList[this.activeTabs - 1]
      await this.getUserList({ type: filterPicked.value, isRegistryOwner: this.isRegistryOwner, ...this.query })
    },
  },
}
</script>
